module.exports = __webpack_public_path__ + "img/videoTest2.b712b509.png";